import { cva } from 'class-variance-authority';

export const collectionCardVariants = cva('flex flex-col items-end gap-4 p-3 rounded-3xl border border-white/10', {
  variants: {
    rarity: {
      common:
        'bg-[linear-gradient(141.57deg,rgba(255,255,255,0.25)_5.75%,rgba(0,0,0,0)_94.25%),linear-gradient(0deg,rgba(255,255,255,0.05),rgba(255,255,255,0.05))]',
      uncommon:
        'bg-[linear-gradient(141.57deg,rgba(247,164,180,0.5)_5.75%,rgba(0,0,0,0)_94.25%),linear-gradient(0deg,rgba(255,255,255,0.05),rgba(255,255,255,0.05))]',
      rare: 'bg-[linear-gradient(141.57deg,rgba(93,160,220,0.5)_5.75%,rgba(0,0,0,0)_94.25%),linear-gradient(0deg,rgba(255,255,255,0.05),rgba(255,255,255,0.05))]',
      'ultra-rare':
        'bg-[linear-gradient(141.57deg,rgba(113,200,120,0.5)_5.75%,rgba(0,0,0,0)_94.25%),linear-gradient(0deg,rgba(255,255,255,0.05),rgba(255,255,255,0.05))]',
      'secret-rare':
        'bg-[linear-gradient(141.57deg,rgba(162,127,236,0.5)_5.75%,rgba(0,0,0,0)_94.25%),linear-gradient(0deg,rgba(255,255,255,0.05),rgba(255,255,255,0.05))]',
      ultimate:
        'bg-[linear-gradient(141.57deg,rgba(238,158,16,0.5)_5.75%,rgba(0,0,0,0)_94.25%),linear-gradient(0deg,rgba(255,255,255,0.05),rgba(255,255,255,0.05))]',
      heirloom:
        'bg-[linear-gradient(141.57deg,rgba(252,30,115,0.5)_5.75%,rgba(0,0,0,0)_94.25%),linear-gradient(0deg,rgba(255,255,255,0.05),rgba(255,255,255,0.05))]',
      wrapped:
        'bg-[linear-gradient(141.57deg,rgba(255,255,255,0.25)_5.75%,rgba(0,0,0,0)_94.25%),linear-gradient(0deg,rgba(255,255,255,0.05),rgba(255,255,255,0.05))]',
      legendary: 'bg-[#747578]',
      black: 'bg-black',
    },
  },
  defaultVariants: {
    rarity: 'common',
  },
});

export const rarityBadgeVariants = cva('flex justify-center items-center gap-1 px-2.5 py-1.5 rounded-2xl border-none', {
  variants: {
    rarity: {
      common: 'bg-[#747578]',
      uncommon: 'bg-[#F7A4B4]',
      rare: 'bg-[#5DA0DC]',
      'ultra-rare': 'bg-[#71C878]',
      'secret-rare': 'bg-[#A27FEC]',
      ultimate: 'bg-[#EE9E10]',
      heirloom: 'bg-[#FC1E73]',
    },
  },
  defaultVariants: {
    rarity: 'common',
  },
});
